<template>
    <div>
        <el-dialog v-model="examExistPromptyShow" title="Tips" width="500" :show-close="false" :align-center="true"
            :close-on-click-modal="false" :close-on-press-escape="false">
            <template #header>
                <div class="close_icon" @click="closePopup" v-if="leaveNum < (paperOtherRule.pageSwitchLimit?paperOtherRule.pageSwitchLimit:paperOtherRule.preventSwitchPageTimes)">
                    <el-icon :size="20">
                        <CloseBold />
                    </el-icon>
                </div>
            </template>
            <div class="dialog_content flex flexcolumn Flexalign">
                <el-image class="exam_exist_promty mt-40" :src="imgPath('exam_exist_promty.png')"></el-image>
                <div class="promty_text mt-20">您已经离开考试 {{ leaveNum }} 次</div>
                <div class="promty_sub_text mt-15">当离开超过{{ (paperOtherRule.pageSwitchLimit?paperOtherRule.pageSwitchLimit:paperOtherRule.preventSwitchPageTimes) }}次将被强制交卷</div>
                <div class="btn_start mt-30 cursor_pointer" :class="[(leaveNum>=(paperOtherRule.pageSwitchLimit?paperOtherRule.pageSwitchLimit:paperOtherRule.preventSwitchPageTimes))?'btn_gray':'']"
                    @click="handleReturnFullscreen">
                    {{btnText}}</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "GjkcH5ExamExistPromty",
    props: {
        paperOtherRule: {}
    },

    data() {
        return {
            examExistPromptyShow: false,
            fullscreen: false,
            btnText: "返回全屏",
            leaveNum: 1,
        };
    },

    watch: {
        leaveNum(newVal) {
            console.log(this.paperOtherRule,666666)
            if (newVal >= (this.paperOtherRule.pageSwitchLimit?this.paperOtherRule.pageSwitchLimit:this.paperOtherRule.preventSwitchPageTimes)) {
                this.btnText = "强制交卷";
                // 超过2次自动触发强制交卷
                this.$emit('force-submit');
            } else {
                this.btnText = "返回全屏";
            }
        }
    },

    mounted() { },

    methods: {
        closePopup() {
            if (this.leaveNum < (this.paperOtherRule.pageSwitchLimit?this.paperOtherRule.pageSwitchLimit:this.paperOtherRule.preventSwitchPageTimes)) {
                this.examExistPromptyShow = false;
                // 关闭弹窗时也触发返回全屏
                this.$emit('return-fullscreen');
            }
            // 超过2次不允许关闭弹窗
        },

        // 处理返回全屏
        handleReturnFullscreen() {
            if (this.leaveNum < (this.paperOtherRule.pageSwitchLimit?this.paperOtherRule.pageSwitchLimit:this.paperOtherRule.preventSwitchPageTimes)) {
                // 触发返回全屏事件
                this.$emit('return-fullscreen');
                this.examExistPromptyShow = false;
            } else {
                // 超过2次触发强制交卷
                this.$emit('force-submit');
                this.examExistPromptyShow = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
:deep(.el-dialog) {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 0;
    width: 502px;
    height: 379px;
    position: relative;
}

:deep(.el-dialog__header) {
    position: relative;
    padding: 0 20px;
    box-sizing: border-box;
    text-align: start;
}

.header {
    font-size: 20px;
    color: #333333;
    line-height: 60px;
    border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.close_icon {
    position: absolute;
    top: 20px;
    right: 20px;
    color: #333333;
    cursor: pointer;
}

.dialog_content {
    .exam_exist_promty {
        width: 150px;
        height: 150px;
    }

    .promty_text {
        font-weight: bold;
        font-size: 20px;
        color: #303030;

        .blue_active {
            color: #3FADFD;
        }
    }

    .promty_sub_text {
        font-size: 16px;
        color: #909090;
    }

    .btn_start {
        width: 156px;
        height: 48px;
        background: linear-gradient(97deg, #00D498 0%, #00D5C2 100%);
        border-radius: 30px;
        line-height: 48px;
        text-align: center;
        color: #fff;
        cursor: pointer;
    }

    .btn_gray {
        background: #B3B3B3;
        cursor: not-allowed;
    }
}
</style>